import { render, staticRenderFns } from "./ExternalAccessNoticePage.vue?vue&type=template&id=1b39dc2a&"
import script from "./ExternalAccessNoticePage.vue?vue&type=script&lang=ts&"
export * from "./ExternalAccessNoticePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports